(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dose-mobile-refinements"] && !Shopify.designMode) return;
  try {
    (()=>{
  if(document.documentElement.lang.split('-')[0]!=='en')return;
  const update=()=>{
    const heading=document.querySelector('#insta-feed > h2');
    if(!heading)return false;
    if(heading.textContent.trim()==='Instagram’da dose.day')heading.textContent='dose.day on Instagram';
    return true;
  };
  if(update())return;
  const observer=new MutationObserver(()=>{if(update())observer.disconnect();});
  observer.observe(document.body,{childList:true,subtree:true});
  setTimeout(()=>observer.disconnect(),30000);
})();
  } catch(e) { console.error(e); }
})();

})();
